// The health of a video, as a row of lit and unlit dots.
//
// The point is the unlit ones: scanning the rail shows what is still missing
// across the whole library without opening a single video.
//
// The lamps are generated from CHECKLIST, so "every lamp lit" and "ready" are
// the same statement by construction rather than by two lists agreeing.

import React from 'react';
import { Tooltip } from '@mui/material';
import { CHECKLIST, SUBTITLE_LABELS, deriveStatus } from './schema';

// Half-done is its own state, and only the subtitles check can be in it: a
// poster either exists or does not, but a video can carry three of its five
// tracks. It is drawn as a ring rather than a filled dot -- present, not
// finished -- and it is deliberately not `is-on`, so "every lamp lit" still
// means the same thing as `ready`.
function ledState(status, key) {
  if (status[key]) return ' is-on';
  if (key === 'subtitles' && status.subtitlesPartial) return ' is-partial';
  return '';
}

function ledTitle(status, key, label) {
  if (key === 'subtitles' && status.subtitlesPartial) {
    return `${label}: missing ${status.subtitlesMissing
      .map((lang) => SUBTITLE_LABELS[lang] || lang)
      .join(', ')}`;
  }
  return `${label}: ${status[key] ? 'yes' : 'missing'}`;
}

export function StatusLeds({ video, showStale = true }) {
  const status = deriveStatus(video);

  return (
    <span className="admin-leds">
      {CHECKLIST.map(({ key, label }) => (
        <Tooltip key={key} title={ledTitle(status, key, label)} placement="top">
          <span className={`admin-led${ledState(status, key)}`} />
        </Tooltip>
      ))}
      {showStale && status.stale && (
        <Tooltip title="Subtitles or chapters are flagged out of date" placement="top">
          <span className="admin-led is-warn is-on" />
        </Tooltip>
      )}
    </span>
  );
}

export default StatusLeds;
